// extracted by mini-css-extract-plugin
module.exports = {"container":"_3mqJoQNmTT3mFliXICeUrK","controls":"_ZDTIVIWAiLWwfIgAY9MO","button":"_3DkZvOyfZc8kOGZV20Hhoi","icon":"_3B8jJHXUuIF4LsSFwcK6RR","prev":"_2wVBUvwXuC6eI31FiklY5O"};